// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__pd1wO","selects":"Documents_selects__3EL1r"};